import { DispatchStatus, OrderState } from '@treadinc/horizon-api-spec';
import { partition } from 'lodash-es';

export enum DispatchURLParams {
  VIEW = 'view',
  TAB = 'tab',
  ENTITY = 'entity',
  UNASSIGNED_VIEW_MODE = 'unassigned_view_mode',
}

export enum UnassignedViewMode {
  ORDERS = 'orders',
  JOBS = 'jobs',
}

export enum OrdersAssignedTargetEntity {
  ORDERS = 'orders',
  PROJECTS = 'projects',
}

export enum OrdersDispatchStorageKeys {
  APPLIED_FILTERS = 'ordersDispatch_appliedFilters',
  APPLIED_ORDERS_SORT = 'ordersDispatch_appliedOrdersSort',
  APPLIED_ORDERS_SORT_DEFAULT = 'ordersDispatch_appliedOrdersSortDefault',
  DRIVER_PANEL_AVAILABILITY_FILTER = 'ordersDispatch_driverPanelAvailabilityFilter',
  TAB_PARAM = `dispatch_${DispatchURLParams.TAB}`,
  VIEW_PARAM = `dispatch_${DispatchURLParams.VIEW}`,
  EXPANDED_STATE = `dispatch_expandedState`,
  GRID_EXPANDED_STATE = `dispatch_gridExpandedState`,
  PRESENTATION = `dispatch_presentation`,
  UNASSIGNED_VIEW_MODE = `dispatch_${DispatchURLParams.UNASSIGNED_VIEW_MODE}`,
}

export enum DriverSchedulerStoreStorageKeys {
  APPLIED_ASSIGNED_JOBS_FILTERS = 'driverScheduler_appliedAssignedJobsFilters',
  JOBS_AVAILABLE_OPTIONS = 'driverScheduler_jobsAvailableOptions',
}

// oxlint-disable-next-line prefer-const
let [EXTERNAL_TAB_ORDER_STATES, ORDERS_TAB_ORDER_STATES] = partition(
  Object.values(OrderState),
  (value) => value === OrderState.PENDING_REQUEST || value === OrderState.REJECTED,
);
ORDERS_TAB_ORDER_STATES = ORDERS_TAB_ORDER_STATES.filter((value) => {
  const isCanceledOrRejected = [OrderState.CANCELED, OrderState.REJECTED].includes(value);

  return !isCanceledOrRejected;
});
export const ALL_ORDERS_TAB_ORDER_STATES = Object.values(OrderState).filter(
  (value) => value !== OrderState.PENDING_REQUEST,
);
export { EXTERNAL_TAB_ORDER_STATES, ORDERS_TAB_ORDER_STATES };

export const dispatchStatusLabelKeys = {
  [DispatchStatus.UNASSIGNED]: 'dispatch.summary_counts.unassigned',
  [DispatchStatus.ASSIGNED]: 'dispatch.summary_counts.assigned',
  [DispatchStatus.SENT]: 'dispatch.summary_counts.sent',
  [DispatchStatus.REJECTED]: 'dispatch.summary_counts.rejected',
  [DispatchStatus.ACCEPTED]: 'dispatch.summary_counts.accepted',
  [DispatchStatus.ENROUTE]: 'dispatch.summary_counts.en_route',
  [DispatchStatus.LOADED]: 'dispatch.summary_counts.loaded',
  [DispatchStatus.UNLOADED]: 'dispatch.summary_counts.unloaded',
  [DispatchStatus.COMPLETED]: 'dispatch.summary_counts.completed',
  [DispatchStatus.CANCELED]: 'dispatch.summary_counts.canceled',
} satisfies Record<DispatchStatus, string>;

export const dispatchStatusTooltipKeys = {
  [DispatchStatus.UNASSIGNED]: 'dispatch.summary_counts.tooltips.unassigned',
  [DispatchStatus.ASSIGNED]: 'dispatch.summary_counts.tooltips.assigned',
  [DispatchStatus.SENT]: 'dispatch.summary_counts.tooltips.sent',
  [DispatchStatus.REJECTED]: 'dispatch.summary_counts.tooltips.rejected',
  [DispatchStatus.ACCEPTED]: 'dispatch.summary_counts.tooltips.accepted',
  [DispatchStatus.ENROUTE]: 'dispatch.summary_counts.tooltips.en_route',
  [DispatchStatus.LOADED]: 'dispatch.summary_counts.tooltips.loaded',
  [DispatchStatus.UNLOADED]: 'dispatch.summary_counts.tooltips.unloaded',
  [DispatchStatus.COMPLETED]: 'dispatch.summary_counts.tooltips.completed',
  [DispatchStatus.CANCELED]: 'dispatch.summary_counts.tooltips.canceled',
} satisfies Record<DispatchStatus, string>;
